// Store map initialization status and retry count
let mapInitialized = false;
let retryCount = 0;
let map;
let marker;
let geocoder;
let mapControlsAdded = false;

const deliveryZoneCenter = { lat: 25.044493707664056, lng: -77.35063549053842 };
const allowedDeliveryAreas = ['nassau', 'paradise island'];

// Initialize global initMap function first
function initMap() {
  try {
    showLoadingState();

    // Check if Google Maps API is properly loaded
    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
      throw new Error('Google Maps API not loaded');
    }

    const mapElement = document.getElementById('location-map');
    if (!mapElement) {
      throw new Error('Map element not found');
    }

    // Initialize the map
    map = new google.maps.Map(mapElement, {
      center: deliveryZoneCenter,
      zoom: 12,
      gestureHandling: 'greedy'
    });

    geocoder = new google.maps.Geocoder();

    // Create draggable marker
    marker = new google.maps.Marker({
      position: deliveryZoneCenter,
      map: map,
      draggable: true,
      title: 'Drag to select delivery location'
    });

    // Handle marker drag end
    marker.addListener('dragend', function() {
      const position = marker.getPosition();
      checkAndUpdateLocation(position.lat(), position.lng());
    });

    // Handle map click
    map.addListener('click', function(e) {
      marker.setPosition(e.latLng);
      checkAndUpdateLocation(e.latLng.lat(), e.latLng.lng());
    });

    // Add map controls
    addMapControls();

    mapInitialized = true;
    hideLoadingState();

  } catch (error) {
    console.error('Map initialization error:', error);
    hideLoadingState();
    retryMapInitialization();
  }
}

function retryMapInitialization() {
  if (!mapInitialized && retryCount < 3) {
    retryCount++;
    console.log(`Retrying map initialization (attempt ${retryCount})`);
    setTimeout(initMap, 1000 * retryCount);
  } else if (!mapInitialized) {
    showMapErrorToUser();
  }
}

function showLoadingState() {
  const mapContainer = document.getElementById('location-map');
  if (mapContainer && !mapContainer.querySelector('.map-loading')) {
    mapContainer.innerHTML = `
      <div class="map-loading">
        <div class="loading-spinner"></div>
        <p>Loading map...</p>
      </div>
    `;
  }
}

function hideLoadingState() {
  const loadingElement = document.querySelector('.map-loading');
  if (loadingElement) {
    loadingElement.style.display = 'none';
  }
}

function showMapErrorToUser() {
  const mapContainer = document.getElementById('location-map');
  if (mapContainer) {
    mapContainer.innerHTML = `
      <div class="map-error">
        <p>We couldn't load the map. Please try these options:</p>
        <ul>
          <li>Refresh the page</li>
          <li>Check your internet connection</li>
          <li>Disable ad blockers for this site</li>
        </ul>
        <button onclick="window.location.reload()">Reload Page</button>
      </div>
    `;
  }
}

function addMapControls() {
  if (mapControlsAdded) return;

  const locationContainer = document.querySelector('.location-container');
  if (!locationContainer) return;

  if (document.querySelector('.map-controls')) {
    mapControlsAdded = true;
    return;
  }

  const controlsContainer = document.createElement('div');
  controlsContainer.className = 'map-controls';
  controlsContainer.innerHTML = `
    <button id="zoom-in-btn" class="map-control-btn" title="Zoom in">+</button>
    <button id="zoom-out-btn" class="map-control-btn" title="Zoom out">-</button>
    <button id="recenter-btn" class="map-control-btn" title="Recenter">⌖</button>
  `;
  locationContainer.appendChild(controlsContainer);

  document.getElementById('zoom-in-btn')?.addEventListener('click', () => {
    if (map) map.setZoom(map.getZoom() + 1);
  });

  document.getElementById('zoom-out-btn')?.addEventListener('click', () => {
    if (map) map.setZoom(map.getZoom() - 1);
  });

  document.getElementById('recenter-btn')?.addEventListener('click', () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        if (map) map.setCenter(pos);
        if (marker) marker.setPosition(pos);
        checkAndUpdateLocation(pos.lat, pos.lng);
      });
    }
  });

  mapControlsAdded = true;
}

// Unified location validation and update
function checkAndUpdateLocation(lat, lng) {
  if (!mapInitialized) return;
  geocodeLatLng(lat, lng);
}

// Check if location is within Nassau or Paradise Island
function isInDeliveryZoneFromResult(geocodeResult) {
  if (!geocodeResult) return false;

  const fullText = [
    geocodeResult.formatted_address || '',
    ...(geocodeResult.address_components || []).map(component => component.long_name || '')
  ].join(' ').toLowerCase();

  return allowedDeliveryAreas.some(area => fullText.includes(area));
}

// Get current location
document.getElementById('get-location-btn')?.addEventListener('click', function() {
  if (!mapInitialized) {
    showLocationError('Map is not ready yet. Please try again.');
    return;
  }

  if (navigator.geolocation) {
    showLocationMessage('Please allow location access...');

    navigator.geolocation.getCurrentPosition(
      position => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        if (marker) marker.setPosition(pos);
        checkAndUpdateLocation(pos.lat, pos.lng);
      },
      error => {
        let errorMessage;
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Location access was denied. Please enter your address manually or enable location services.';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Location information is unavailable. Please enter your address manually.';
            break;
          case error.TIMEOUT:
            errorMessage = 'The request timed out. Please try again or enter your address manually.';
            break;
          default:
            errorMessage = 'An unknown error occurred while getting your location.';
        }
        showLocationError(errorMessage);
        document.getElementById('address-input')?.focus();
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  } else {
    showLocationError('Geolocation is not supported by your browser. Please enter your address manually.');
  }
});

// Manual address verification
document.getElementById('manual-location-btn')?.addEventListener('click', function() {
  if (!mapInitialized) {
    showLocationError('Map is not ready yet. Please try again.');
    return;
  }

  const addressInput = document.getElementById('address-input');
  const address = addressInput ? addressInput.value : '';

  if (address.trim() === '') {
    showLocationError('Please enter an address');
    return;
  }

  geocoder.geocode({ address: address + ', Nassau, Bahamas' }, (results, status) => {
    if (status === 'OK' && results[0]) {
      const result = results[0];
      const location = result.geometry.location;
      const lat = location.lat();
      const lng = location.lng();

      if (isInDeliveryZoneFromResult(result)) {
        if (marker) marker.setPosition(location);
        updateLocation(lat, lng, formatAddress(result));
        showLocationSuccess('Location set: ' + formatAddress(result));
      } else {
        showLocationError('Delivery is only available in Nassau and Paradise Island');
      }
    } else {
      showLocationError('Could not find this address. Please try being more specific.');
    }
  });
});

// Format address to be more user friendly
function formatAddress(geocodeResult) {
  const addressComponents = geocodeResult.address_components || [];
  const formattedAddress = geocodeResult.formatted_address || '';

  // Extract the components we want to use
  const components = {
    streetNumber: getComponent(addressComponents, 'street_number'),
    route: getComponent(addressComponents, 'route'),
    neighborhood: getComponent(addressComponents, 'neighborhood') || getComponent(addressComponents, 'sublocality'),
    locality: getComponent(addressComponents, 'locality'),
    administrativeArea: getComponent(addressComponents, 'administrative_area_level_1') || getComponent(addressComponents, 'administrative_area_level_2'),
    postalCode: getComponent(addressComponents, 'postal_code')
  };

  // Build the address in a natural order
  let cleanAddress = '';

  // Street address part
  if (components.streetNumber && components.route) {
    cleanAddress = `${components.streetNumber} ${components.route}`;
  } else if (components.route) {
    cleanAddress = components.route;
  } else if (components.neighborhood) {
    cleanAddress = components.neighborhood;
  }

  // City or local area part
  if (components.locality) {
    if (cleanAddress.length > 0) {
      cleanAddress += `, ${components.locality}`;
    } else {
      cleanAddress = components.locality;
    }
  } else if (components.administrativeArea) {
    if (cleanAddress.length > 0) {
      cleanAddress += `, ${components.administrativeArea}`;
    } else {
      cleanAddress = components.administrativeArea;
    }
  }

  // If still empty, use postal code with locality if available
  if (cleanAddress.length === 0 && components.postalCode) {
    cleanAddress = components.postalCode;
    if (components.locality) {
      cleanAddress += `, ${components.locality}`;
    }
  }

  // Final fallback
  if (!cleanAddress || cleanAddress.length < 3) {
    cleanAddress = formattedAddress
      .replace(/,\s*Bahamas$/i, '')
      .replace(/,,\s*/g, ', ')
      .replace(/\s+/g, ' ')
      .replace(/^,\s*/, '')
      .trim();

    if (components.postalCode && cleanAddress.endsWith(components.postalCode)) {
      cleanAddress = cleanAddress.substring(0, cleanAddress.length - components.postalCode.length)
        .replace(/,\s*$/, '')
        .trim();
    }
  }

  return cleanAddress || formattedAddress;
}

// Helper to get address component
function getComponent(components, type) {
  const component = components.find(c => c.types.includes(type));
  return component ? component.long_name : '';
}

// Update location data
function updateLocation(lat, lng, formattedAddress) {
  if (!mapInitialized) return;

  const mapLink = `https://www.google.com/maps/?q=${lat},${lng}&ll=${lat},${lng}&z=16`;

  // Update hidden form fields
  const latField = document.getElementById('delivery-lat');
  const lngField = document.getElementById('delivery-lng');
  const addressField = document.getElementById('delivery-address');
  const mapLinkField = document.getElementById('delivery-map-link');

  if (latField) latField.value = lat;
  if (lngField) lngField.value = lng;
  if (addressField) addressField.value = formattedAddress;
  if (mapLinkField) mapLinkField.value = mapLink;

  // Also store in cart attributes
  const attributes = {
    'Delivery Latitude': lat,
    'Delivery Longitude': lng,
    'Delivery Address': formattedAddress,
    'Delivery Map Link': mapLink
  };

  updateCartAttributes(attributes);

  if (map) map.setCenter({ lat: lat, lng: lng });
}

// Clear location data if outside area
function clearLocationData() {
  const latField = document.getElementById('delivery-lat');
  const lngField = document.getElementById('delivery-lng');
  const addressField = document.getElementById('delivery-address');
  const mapLinkField = document.getElementById('delivery-map-link');

  if (latField) latField.value = '';
  if (lngField) lngField.value = '';
  if (addressField) addressField.value = '';
  if (mapLinkField) mapLinkField.value = '';
}

function updateCartAttributes(attributes) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ attributes: attributes })
  })
    .then(response => response.json())
    .catch(error => console.error('Error updating cart:', error));
}

// Geocode coordinates to address
function geocodeLatLng(lat, lng) {
  const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

  geocoder.geocode({ location: latlng }, (results, status) => {
    if (status === 'OK' && results[0]) {
      const result = results[0];

      if (isInDeliveryZoneFromResult(result)) {
        const formattedAddress = formatAddress(result);
        updateLocation(lat, lng, formattedAddress);

        const addressInput = document.getElementById('address-input');
        if (addressInput) addressInput.value = formattedAddress;

        showLocationSuccess('Location set: ' + formattedAddress);
      } else {
        clearLocationData();
        showLocationError('Delivery is only available in Nassau and Paradise Island');
      }
    } else {
      showLocationError('Could not find address for this location. Please try moving the marker slightly.');
    }
  });
}

// Helper functions for UI feedback
function showLocationMessage(message, type = 'info') {
  const locationMessage = document.getElementById('location-message');
  if (locationMessage) {
    locationMessage.textContent = message;
    locationMessage.className = `location-message ${type}-message`;
  }
}

function showLocationSuccess(message) {
  showLocationMessage(message, 'success');
  highlightInputField('#4CAF50');
}

function showLocationError(message) {
  showLocationMessage(message, 'error');
  highlightInputField('#ff0000');
}

function highlightInputField(color) {
  const input = document.getElementById('address-input');
  if (input) {
    input.style.border = `1px solid ${color}`;
    setTimeout(() => {
      input.style.border = '1px solid #ddd';
    }, 3000);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Move the location container before checkout buttons
  const checkoutForm = document.querySelector('[action="/cart"]') ||
    document.querySelector('form[action="/checkout"]');

  if (checkoutForm) {
    const locationContainer = document.querySelector('.location-container');
    const checkoutButtons = checkoutForm.querySelector('[name="checkout"], [href*="/checkout"]')?.parentElement;

    if (locationContainer && checkoutButtons) {
      checkoutForm.insertBefore(locationContainer, checkoutButtons);
    }
  }

  // Enhanced checkout validation
  function validateLocation(e) {
    const deliveryAddress = document.getElementById('delivery-address')?.value;
    const deliveryLink = document.getElementById('delivery-map-link')?.value;

    if (!deliveryAddress || !deliveryLink) {
      e.preventDefault();
      showLocationError('Please set your delivery location before checkout');
      document.querySelector('.location-container')?.scrollIntoView({
        behavior: 'smooth'
      });
      return false;
    }
    return true;
  }

  // Event delegation for all checkout buttons
  document.body.addEventListener('click', function(e) {
    const checkoutBtn = e.target.closest('[name="checkout"], [href*="/checkout"]');
    if (checkoutBtn && !validateLocation(e)) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
});

// Load Google Maps API safely
function loadGoogleMaps() {
  if (window.google && window.google.maps) {
    initMap();
    return;
  }

  if (document.querySelector('script[data-google-maps="true"]')) {
    return;
  }

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCksNWpRBV7eFv3qE7aVHMkWqk_hGGHDXw&libraries=places,geometry&callback=initMap`;
  script.async = true;
  script.defer = true;
  script.setAttribute('data-google-maps', 'true');
  script.onerror = () => {
    console.error('Google Maps script failed to load');
    retryMapInitialization();
  };
  document.head.appendChild(script);
}



// Start the process
document.addEventListener('DOMContentLoaded', loadGoogleMaps);

